import { Button, Container, Header } from '@cloudscape-design/components';
// components
import { FileSelector } from './Components/FileSelector';
import { FileProcessing } from './Components/FileProcessing';
import { DocumentContext } from '../context/documentContext';
import { useContext } from 'react';

export const UploadDocument = () => {
const {uploadProcessing} = useContext(DocumentContext)
  return (
    <Container

      header={
        <Header
        variant="h2"
        >
         Upload Files for Analysis
        </Header>
      }
      
    > 
      {uploadProcessing ? <FileProcessing /> :  <FileSelector />}
    </Container>
  );
}